export const UPLOAD_SERVICE_BASE_URL =
  process.env.UPLOAD_SERVICE_INNER_URL || 'https://tds.investkavkaz.ru';
export const QUOTE_ASPECT_RATIO = 1;
export const PREVIEW_ASPECT_RATIO = 16 / 9;
export const MAIN_IMAGE_ASPECT_RATIO = 16 / 7;
export const CONTENT_IMAGE_ASPECT_RATIO = 16 / 9;
export const COLLAGE_IMAGE_ASPECT_RATIO = 3 / 2;
export const VERTICAL_COLLAGE_IMAGE_ASPECT_RATIO = 3 / 4;
